// Module
var code = `<form novalidate name="\$ctrl.form">
  <div class="form-column">
    <form-section form-title="'Basic data'">
      <form-section-field field-title="'Group number'" ng-if="\$ctrl.profile.customerId">
        <input class="disabled"
               ng-model="\$ctrl.profile.customerNumber"
               type="text"
               disabled />
      </form-section-field>
      <form-section-field field-title="'Group name'">
        <input ng-if="\$ctrl.profile.customerId"
               ng-model="\$ctrl.profile.name"
               type="text"
               maxlength="64"
               required
        />
        <input ng-if="!\$ctrl.profile.customerId"
               ng-model="\$ctrl.profile.name"
               ng-disabled="\$ctrl.autogeneratedGroupName"
               type="text"
               placeholder="{{\$ctrl.autogeneratedGroupName ? '[auto-generated]' : ''}}"
               ng-required="!\$ctrl.autogeneratedGroupName"
        />
      </form-section-field>
      <form-section-field field-title="'Group description'">
        <input ng-model="\$ctrl.profile.description"
               type="text"
               ng-required="\$ctrl.propertyConfigService.required('customer', 'group', 'description')"/>
      </form-section-field>

      <form-section-field field-title="'Group Fund Account'">
        <selectize
          options="\$ctrl.cbuAccounts"
          config="\$ctrl.selectAccountConfig"
          ng-model="\$ctrl.profile.groupFundAccountId">
        </selectize>
      </form-section-field>
    </form-section>

    <form-section form-title="'Group Officers'">
      <div class="alert alert--danger">
        Please remember that any changes to the current group chief borrower will result in the removal of the group fund account.
        <button type="button" class="close" data-dismiss="alert">&times;</button>
      </div>
      <form-section-field field-title="'Chief Borrower'">
        <select
          ng-model="\$ctrl.profile.chiefBorrowerId"
          ng-options="u.id as u.effectiveName for u in \$ctrl.profile.customers"
        ></select>
      </form-section-field>

      <form-section-field field-title="'Group treasurer'">
        <select
          ng-model="\$ctrl.profile.groupTreasurerId"
          ng-options="u.id as u.effectiveName for u in \$ctrl.profile.customers"
        ></select>
      </form-section-field>

      <form-section-field field-title="'Group secretary'">
        <select
          ng-model="\$ctrl.profile.groupSecretaryId"
          ng-options="u.id as u.effectiveName for u in \$ctrl.profile.customers"
        ></select>
      </form-section-field>
    </form-section>

    <form-section form-title="'Contact data'">
      <form-section-field field-title="'Group email'">
        <input ng-model="\$ctrl.profile.email"
               type="email"/>
      </form-section-field>
      <form-section-field field-title="'Group landline number'" ng-if="\$ctrl.propertyConfigService.visible('customer', 'group', 'landline_number')">
        <telephone ng-model="\$ctrl.profile.phones[0].number" ng-required="\$ctrl.propertyConfigService.required('customer', 'group', 'landline_number')"></telephone>
      </form-section-field>
      <form-section-field field-title="'Group mobile number'" ng-if="\$ctrl.propertyConfigService.visible('customer', 'group', 'mobile_number')">
        <telephone ng-model="\$ctrl.profile.phones[1].number" ng-required="\$ctrl.propertyConfigService.required('customer', 'group', 'mobile_number')"></telephone>
      </form-section-field>
    </form-section>

    <form-section form-title="'Compliance'">
      <form-section-field field-title="'Risk level'">
        <select required ng-model="\$ctrl.profile.riskLevelId" ng-options="entry.id as entry.description for entry in \$ctrl.dict.CUSTOMER_RISK_LEVEL"
                ng-required="\$ctrl.propertyConfigService.required('customer', 'group', 'risk_level')">
      </select>
      </form-section-field>
    </form-section>
  </div>

  <div class="form-column">
    <form-section form-title="'Bank Officers'" ng-if="\$ctrl.loanOfficersVisible">
      <validator condition="\$ctrl.hasValidLoanOfficerConfiguration()"></validator>
      <form-section-field field-title="'Loan Collector'">
        <select
          ng-model="\$ctrl.profile.loanCollectorId"
          ng-options="u.id as u.effectiveName for u in \$ctrl.allLoanCollectors"
          ng-required="!\$ctrl.hasValidLoanOfficerConfiguration()"
          required
        ></select>
      </form-section-field>
      <form-section-field field-title="'Account developer'">
        <select
          ng-model="\$ctrl.profile.accountDeveloperId"
          ng-options="u.id as u.effectiveName for u in \$ctrl.allUsers"
          ng-required="!\$ctrl.hasValidLoanOfficerConfiguration()"
        ></select>
      </form-section-field>
      <form-section-field field-title="'Area manager'">
        <select
          ng-model="\$ctrl.profile.areaManagerId"
          ng-options="u.id as u.effectiveName for u in \$ctrl.allUsers"
          ng-required="!\$ctrl.hasValidLoanOfficerConfiguration()"
        ></select>
      </form-section-field>
    </form-section>

    <form-section form-title="'Center'" ng-if="\$ctrl.profile.center">
      <form-section-field field-title="'Center name'">
        <input class="disabled" value="{{\$ctrl.profile.center.name}}" type="text" disabled/>
      </form-section-field>
      <form-section-field field-title="'Center reference no.'">
        <input class="disabled" value="{{\$ctrl.profile.center.id}}" type="text" disabled/>
      </form-section-field>
      <form-section-field field-title="'Center branch'">
        <input class="disabled" value="{{\$ctrl.getBranchName(\$ctrl.profile.center.branchId)}}" type="text" disabled/>
      </form-section-field>
      <form-section-field field-title="'Loan officer'">
        <input class="disabled" value="{{\$ctrl.centerLoanOfficerName}}" type="text" disabled/>
      </form-section-field>
      <form-section-field field-title="'Loan collector'">
        <input class="disabled" value="{{\$ctrl.centerLoanCollectorName}}" type="text" disabled/>
      </form-section-field>
      <form-section-field field-title="'Transfer to another center'">
        <center-picker
          on-choose="\$ctrl.transferCustomerGroupToAnotherCenter"
          filter-result="\$ctrl.filterCenterPickerResult"
          button-label="'Transfer'"
        ></center-picker>
      </form-section-field>
    </form-section>
  </div>

  <div class="clearfix"></div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/group-loans/profile/sub-components/group-data.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;